import React, { useState, useEffect } from 'react';
import './Common.css';
import { useAuth } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar';
import Footer from "../../Footer";
import { ChevronLeft, ChevronRight } from 'lucide-react'; // Import icons for slider buttons
import slider1 from '../../../assets/slider1.png';
import slider2 from '../../../assets/slider2.png';
import slider3 from '../../../assets/slider3.png';
import slider4 from '../../../assets/slider4.png';

const Organization = () => {
    const [activeTab, setActiveTab] = useState('HR Solutions');
    const { user } = useAuth();
    const navigate = useNavigate();

    // Slider state and logic
    const [currentSlide, setCurrentSlide] = useState(0);

    const images = [
        {
            src: slider3,
            title: 'Complexity to Simplicity',
            description: '',
        },
        {
            src: slider4,
            title: '',
            description: 'All our training programs are designed by blending modern science with universal science, the laws of nature, the depth and dimensions of life, existential realities, and real-life personal and professional experiences. Our endeavor is not just to transfer knowledge (information) but also to help you understand it from different perspectives and experience it firsthand.',
        },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            nextSlide();
        }, 5000);

        return () => clearInterval(interval);
    }, [currentSlide]);

    const nextSlide = () => {
        setCurrentSlide((prevSlide) =>
            prevSlide === images.length - 1 ? 0 : prevSlide + 1
        );
    };

    const prevSlide = () => {
        setCurrentSlide((prevSlide) =>
            prevSlide === 0 ? images.length - 1 : prevSlide - 1
        );
    };

    const handleTakeAssessment = () => {
        if (user) {
            navigate('/quiz-selection');
        } else {
            navigate('/login');
        }
    };

    return (
        <div className="page">
            <Navbar />
            <div className="hero-section">
                {/* Replace the static image with the slider */}
                <div className="hero-slider">
                    <button className="slider-btn prev" onClick={prevSlide}>
                        <ChevronLeft size={24} />
                    </button>
                    <div className="slider-container">
                        {images.map((image, index) => (
                            <div key={index} className={`slide ${index === currentSlide ? 'active' : ''}`}>
                                <img src={image.src} alt={`Slide ${index + 1}`} className="slide-image" />
                                <div className="slide-content">
                                    <p>{image.description}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                    <button className="slider-btn next" onClick={nextSlide}>
                        <ChevronRight size={24} />
                    </button>
                </div>
                <h1>Organization</h1>
            </div>

            <div className="tabs">
                <button
                    className={activeTab === 'HR Solutions' ? 'active' : ''}
                    onClick={() => setActiveTab('HR Solutions')}
                >
                    HR Solutions
                </button>
                <button
                    className={activeTab === 'training' ? 'active' : ''}
                    onClick={() => setActiveTab('training')}
                >
                    Training and Development
                </button>
            </div>

            <div className="tab-content">
                {activeTab === 'HR Solutions' && (
                    <div>
                        <h2>Complexity to Simplicity</h2>
                        <p>
                            The success of every organization hinges on its people—their vision, ambition, ethics, perseverance, etc. While businesses invest in recruiting talented individuals, the key differentiator between thriving companies and struggling ones lies in how effectively they harness human potential.
                        </p>
                        <p>
                            At UNIAARIV, we provide organizations with scientific, data-driven insights into their workforce, helping HR and leadership teams make informed decisions about recruitment, training, job placement, promotions, succession planning, and restructuring.
                        </p>
                        <p><b>Why Do Some Organizations Excel While Others Struggle? </b></p>
                        <p>Every company hires skilled, ambitious, and capable professionals, yet their outcomes vary drastically. Some businesses achieve exceptional growth, while others stagnate or even collapse—often due to ethical reasoning, poor cultural fit, or ineffective leadership.
                            <b>The critical question is: What makes the difference?</b></p>
                        <h3>Key Factors That Influence Organizational Success-</h3><br />
                        <ul className="principles-list">
                            <li><b>Clarity of Vision & Leadership:</b> Success is driven by how well leadership articulates goals, channels collective energy, and strategizes resource utilization.</li>
                            <li><b>True Potential vs. Qualifications:</b> A degree may indicate intellectual capability, but actual performance depends on emotional intelligence, adaptability, discipline, and alignment with the company’s values.</li>
                            <li><b>Ethics & Values:</b> Over-ambition without ethical grounding can lead to reputational damage. Many organizations fail due to ethical lapses, despite having skilled employees.</li>
                            <li><b>Skill Adaptability:</b> In a fast-changing world, technical expertise alone isn’t enough. Employees must possess the right mindset to evolve with shifting industry trends and challenges.</li>
                            <li><b>Wisdom vs. Intelligence:</b> Intelligence helps employees perform, but wisdom enables them to make ethical, long-term decisions that benefit both the organization and society.</li>
                        </ul>
                    </div>
                )}
                {activeTab === 'training' && (
                    <div>
                        <h2>Complexity to Simplicity</h2>
                        <p>
                            The success of every organization hinges on its people—their vision, ambition, ethics, perseverance, etc. While businesses invest in recruiting talented individuals, the key differentiator between thriving companies and struggling ones lies in how effectively they harness human potential.
                        </p>
                        <p>
                            At UNIAARIV, we provide organizations with scientific, data-driven insights into their workforce, helping HR and leadership teams make informed decisions about recruitment, training, job placement, promotions, succession planning, and restructuring.
                        </p>
                        <p><b>Why Do Some Organizations Excel While Others Struggle? </b></p>
                        <p>Every company hires skilled, ambitious, and capable professionals, yet their outcomes vary drastically. Some businesses achieve exceptional growth, while others stagnate or even collapse—often due to ethical reasoning, poor cultural fit, or ineffective leadership.
                            <b>The critical question is: What makes the difference?</b></p>
                        <h3>Key Factors That Influence Organizational Success-</h3><br />
                        <ul className="principles-list">
                            <li><b>Clarity of Vision & Leadership:</b> Success is driven by how well leadership articulates goals, channels collective energy, and strategizes resource utilization.</li>
                            <li><b>True Potential vs. Qualifications:</b> A degree may indicate intellectual capability, but actual performance depends on emotional intelligence, adaptability, discipline, and alignment with the company’s values.</li>
                            <li><b>Ethics & Values:</b> Over-ambition without ethical grounding can lead to reputational damage. Many organizations fail due to ethical lapses, despite having skilled employees.</li>
                            <li><b>Skill Adaptability:</b> In a fast-changing world, technical expertise alone isn’t enough. Employees must possess the right mindset to evolve with shifting industry trends and challenges.</li>
                            <li><b>Wisdom vs. Intelligence:</b> Intelligence helps employees perform, but wisdom enables them to make ethical, long-term decisions that benefit both the organization and society.</li>
                        </ul>
                    </div>
                )}
            </div>

            <div className="empowers-section">
                <h2>How UNIAARIV Helps Organizations</h2>
                <p><b>UNIAARIV’s True Intrinsic Nature (TrueIN) Model ©</b> provides a revolutionary way to evaluate employees based on scientific and behavioral derived from Universal Human Science and Psychology. </p>
                <p>Make various strategic decisions based on deep insights into employees’ true intrinsic nature and make quick and unbiased decisions: -</p>
                <ul className="empowers-list">
                    <li>
                        Identify the right talent beyond just qualifications, experience, and apparent skillset.
                    </li>
                    <li>
                        Overall suitability of candidate for Recruitment, Promotion, and Succession planning.
                    </li>
                    <li>
                        Identifies potential leaders and grooms them at early stages.
                    </li>
                    <li>
                        Helps transform a non-performer to performer,
                    </li>
                    <li>
                        Identify potential risks at an early stage and Mitigate the risk of possible ethical and moral challenges
                    </li>
                    <li>
                        Identify personalized training needs and help customize Training and Development programs
                    </li>
                </ul>
                <p><b>Transform your workforce with UNIAARIV.</b> Invest in the science of human potential and build an organization that thrives on excellence, ethics, and vision.</p>
            </div>

            <div className="take-assessment-container">
                <button className="take-assessment-btn" onClick={handleTakeAssessment}>
                    Take Assessment
                    <svg className="icon" viewBox="0 0 24 24" fill="currentColor">
                        <path
                            fillRule="evenodd"
                            d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm4.28 10.28a.75.75 0 000-1.06l-3-3a.75.75 0 10-1.06 1.06l1.72 1.72H8.25a.75.75 0 000 1.5h5.69l-1.72 1.72a.75.75 0 101.06 1.06l3-3z"
                            clipRule="evenodd"
                        ></path>
                    </svg>
                </button>
            </div>
            <Footer />
        </div>
    );
};

export default Organization;